import Box from "@mui/material/Box";
import {
  Button,
  TextField,
  Grid,
  OutlinedInput,
  ListItemText,
  Avatar,
  Typography,
} from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { usePermiteAcesso } from "../../Components/Funcionais/Utils";
import { validarSenha } from "../../Components/Funcionais/Utils";
import { validarEmail } from "../../Components/Funcionais/Utils";
import { PutAPI } from "../../Components/Backend/PutAPI";
import { GetAPI } from "../../Components/Backend/GetAPI";
import { useParams } from "react-router-dom";
import APIAxios from "../../Api/APIAxios";
import PageTitle from "../../components/Layout/PageTitle";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import LockIcon from "@mui/icons-material/Lock";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";


export default function UserRegistration() {
  //***************************************   AVISOS E LOADING ************************************************* */
  // CONTROLE DE AVISOS E ALERTAS
  //Funcão para fechar avisos e alertas
  usePermiteAcesso(2); //Controle de Acessos
  const [avisoErro, setAvisoErro] = useState("");
  const [avisoSucesso, setAvisoSucesso] = useState("");
  const [loading, setLoading] = useState(false);
  //************************************************************************************************** */

  const navigate = useNavigate();
  const apiAxios = APIAxios();
  const { id } = useParams();

  const [perfis, setPerfis] = useState([]);
  const [perfisSelecionados, setPerfisSelecionados] = useState([]);
  const [emailError, setEmailError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [senhaValida, setSenhaValida] = useState(false);
  const [confSenha, setConfSenha] = useState("");
  const MAX_SIZE = 2 * 1024 * 1024; // 2MB

  const [formData, setFormData] = useState({
    id: 0,
    nome: "",
    cargo: "",
    email: "",
    senha: "",
    status: "A",
    idEmpresa: 0,
    idPerfil: 0,
    tipo: "A",
    datAceite: "",
  });

  // Este estado guarda a URL temporária para exibir a imagem na tela
  const [previewUrl, setPreviewUrl] = useState(null);

  //Busca Perfil no backend
  const buscaPerfis = async () => {
    setLoading(true);

    const response = await GetAPI(apiAxios, "/perfis");
    setLoading(false);

    if (response.success) {
      setPerfis(response.data);
      carregarAvatar(response.data.id);
    } else {
      setAvisoErro(response.errorMessage || "Erro ao carregar grupos.");
    }
  };

  //Busca Perfil no backend
  const buscaUsuario = async () => {
    setLoading(true);

    const response = await GetAPI(apiAxios, `/usuarios/${id}`);
    setLoading(false);

    if (response.success) {
      setFormData(response.data);
      carregarAvatar(response.data.id);
      setPerfisSelecionados([response.data.idPerfil]);
    } else {
      setAvisoErro(response.errorMessage || "Erro ao carregar grupos.");
    }
  };

  useEffect(() => {
    buscaUsuario();
    buscaPerfis();
  }, []);

  const carregarAvatar = async (id) => {
    //Carrega identificação das imagens
    const response = await GetAPI(apiAxios, '/usuario/avatar/' + id,
      {
        responseType: "blob",
      });

    // Cria uma URL temporária para o blob recebido
    const blobUrl = URL.createObjectURL(response.data);

    setFormData((prev) => ({
      ...prev,
      avatarUrl: blobUrl,
    }));

  };

  const handleChange = (event, tam) => {
    const { name, value } = event.target;

    let valor = value;
    //Limita tamanho do campo
    if (typeof value === "string") {
      valor = valor.slice(0, tam);
    }

    if (typeof value === "string") {
      if (name === "email") {
        valor = valor.toLowerCase();
      } else {
        if (name !== "senha") {
          valor = valor.toUpperCase();
        }
      }
    }

    //Converte o texto para maiusculo
    setFormData((prevData) => ({
      ...prevData,
      [name]: valor,
    }));
  };

  const handleVoltar = () => {
    navigate("/usuarios");
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  const handleValidarSenha = (event) => {
    const { value } = event.target;

    if (value && value.length > 0 && !validarSenha(value)) {
      setAvisoErro("Senha muito fraca.");
      setSenhaValida(false);
    } else {
      setSenhaValida(true);
    }
  };

  const handleValidarEmail = (event) => {
    const { value } = event.target;

    if (!validarEmail(value)) {
      setAvisoErro("E-mail inválido");
      setEmailError(true);
    } else {
      setEmailError(false);
    }
  };


  useEffect(() => {
    if (formData.senha && formData.senha.length > 0 && !validarSenha(formData.senha)) {
      setSenhaValida(false);
    } else {
      setSenhaValida(true);
    }
  }, [formData.senha]);


  const handleSubmit = async (event) => {
    event.preventDefault();
    setAvisoSucesso("");
    setAvisoErro("");

    if (formData.senha || confSenha.length > 0) {
      if (formData.senha !== confSenha) {
        setAvisoErro("A senha e a confirmação de senha não coincidem.");
        return;
      }
    }
    if (formData.senha && formData.senha.length > 0) {
      //Validar senha
      if (!validarSenha(formData.senha)) {
        setAvisoErro("Senha muito fraca.");
        return;
      }
    }

    //Validar email
    if (!validarEmail(formData.email)) {
      setAvisoErro("E-mail inválido.");
      setEmailError(true);
      return;
    }

    const registro = {
      id: formData.id,
      nome: formData.nome,
      cargo: formData.cargo,
      email: formData.email,
      senha: formData.senha,
      status: formData.status,
      idEmpresa: formData.idEmpresa,
      tipo: formData.tipo,
      datAceite: formData.datAceite,
      idPerfil: (formData.idPerfil =
        perfisSelecionados.length > 0 ? perfisSelecionados[0] : null),
    };

    setLoading(true);
    const response = await PutAPI(apiAxios, "/usuario", registro);
    setLoading(false);

    if (response.success) {
      setFormData((prev) => ({
        ...prev,
        ...response.data,
        espacoUtilizado: prev.espacoUtilizado, // garante que não zera
      }));

      setAvisoSucesso("Gestor(a) salvo com sucesso.");
    } else {
      setAvisoErro(response.errorMessage || "Erro ao salvar gestor(a).");
    }
  };

  const uploadAvatar = async (file) => {
    const fd = new FormData();
    fd.append("file", file);

    const resp = await apiAxios.post(`/usuario/avatar/${formData.id}`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return resp.data;
  };

  // Função para processar a nova imagem selecionada
  const handleImageChange = async (e) => {

    setAvisoErro("");
    setAvisoSucesso("");
    setLoading(true);

    const file = e.target.files?.[0];
    if (!file) return;

    //permite escolher o mesmo arquivo novamente
    e.target.value = "";

    // valida tamanho
    if (file.size > MAX_SIZE) {
      setAvisoErro("Imagem maior que 2MB.");
      return;
    }

    // valida extensão (backend aceita apenas .png ou .jpg)
    const ext = file.name.split(".").pop()?.toLowerCase();
    const allowedExt = ["png", "jpg"];
    if (!ext || !allowedExt.includes(ext)) {
      setAvisoErro("Arquivo deve ser PNG ou JPG.");
      return;
    }

    // valida mime-type (mais confiável que só extensão)
    const allowedMime = ["image/png", "image/jpeg"];
    if (!allowedMime.includes(file.type)) {
      setAvisoErro("Tipo de arquivo inválido. Use PNG ou JPG.");
      return;
    }

    // preview local imediato
    const previewUrl = URL.createObjectURL(file);
    setFormData((prev) => ({ ...prev, avatarUrl: previewUrl }));

    try {
      setLoading(true);
      setAvisoErro("");
      setAvisoSucesso("");

      await uploadAvatar(file);

      // Recarrega do backend (opcional, mas garante que está pegando o arquivo salvo)
      await carregarAvatar(formData.id);

      setAvisoSucesso("Imagem atualizada com sucesso!");
    } catch (err) {
      setAvisoErro("Falha ao enviar imagem.");
    } finally {
      setLoading(false);

      // limpa URL temporária do preview (evita vazamento de memória)
      URL.revokeObjectURL(previewUrl);
    }
  };

  return (
    <div>
      {/******************************* TITULO E FUNCIONALIDADES *************************/}
      <PageTitle
        caption="Alterar Gestor"
        setAvisoErro={setAvisoErro}
        avisoErro={avisoErro}
        avisoSucesso={avisoSucesso}
        setAvisoSucesso={setAvisoSucesso}
        loading={loading}
        accentStyle
      />
      {/**********************************************************************************/}
      <Box sx={{ flexGrow: 1, p: 3, overflow: "visible" }}>
        <form onSubmit={handleSubmit}>

          {/* GRID PRINCIPAL */}
          <Grid container spacing={4} alignItems="strech">

            {/* COLUNA ESQUERDA – AVATAR */}
            <Grid item xs={12} md={3} sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              borderRight: { md: "1px solid #e0e0e0" },
              pr: { md: 4 },
              textAlign: "center",
            }}
            >

              <Avatar
                src={previewUrl || formData.avatarUrl}
                sx={{ width: 160, height: 160, mb: 2, border: "1px solid #ccc" }}
              />

              <Button
                variant="outlined"
                component="label"
                startIcon={<AttachFileIcon sx={{ transform: "rotate(45deg)" }} />}
                sx={{
                  mb: 1,
                  textTransform: "none",
                  width: "100%",
                  borderColor: "#1a3865",
                  color: "#1a3865",
                }}
              >
                Atualizar imagem
                <input
                  type="file"
                  hidden
                  accept="image/png,image/jpeg"
                  onChange={handleImageChange}
                />
              </Button>

              <Typography variant="caption" color="textSecondary">
                PNG/JPG - até 2MB
              </Typography>
            </Grid>

            {/* COLUNA DIREITA – FORMULÁRIO */}
            <Grid item xs={12} md={9}>
              <Grid container spacing={2}>

                {/* Nome */}
                <Grid item xs={12}>
                  <TextField
                    label="Nome do Gestor(a)"
                    name="nome"
                    value={formData.nome}
                    onChange={(e) => handleChange(e, 50)}
                    required
                    fullWidth
                  />
                </Grid>

                {/* Cargo */}
                <Grid item xs={12}>
                  <TextField
                    label="Cargo do Gestor(a)"
                    name="cargo"
                    value={formData.cargo}
                    onChange={(e) => handleChange(e, 50)}
                    required
                    fullWidth
                  />
                </Grid>

                {/* Email */}
                <Grid item xs={12}>
                  <TextField
                    label="Email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={(e) => handleChange(e, 50)}
                    onBlur={handleValidarEmail}
                    required
                    fullWidth
                  />
                </Grid>

                {/* Senha */}
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Senha"
                    name="senha"
                    type={showPassword ? "text" : "password"}
                    value={formData.senha}
                    onChange={handleChange}
                    onBlur={handleValidarSenha}
                    fullWidth
                    autoComplete="new-password"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockIcon />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={togglePasswordVisibility}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                {/* Confirmar Senha */}
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Confirmação de Senha"
                    value={confSenha}
                    type={showConfirmPassword ? "text" : "password"}
                    onChange={(e) => setConfSenha(e.target.value)}
                    fullWidth
                    autoComplete="new-password"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockIcon />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={toggleConfirmPasswordVisibility}
                            edge="end"
                          >
                            {showConfirmPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                {/* Perfil */}
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel id="label-status">Perfil</InputLabel>
                    <Select
                      labelId="label-status"
                      label="Perfil"
                      name="perfil"
                      multiple
                      value={perfisSelecionados}
                      onChange={(e) =>
                        setPerfisSelecionados(
                          (Array.isArray(e.target.value)
                            ? e.target.value
                            : [e.target.value]
                          ).map(Number)
                        )
                      }
                      sx={{
                        height: '56px',
                        '& .MuiSelect-select': {
                          display: 'flex',
                          alignItems: 'center',
                          paddingY: '0px',
                          height: '45px',
                        },
                      }}
                      input={<OutlinedInput label="Perfil" />}
                    >
                      {perfis.map((p) => (
                        <MenuItem key={p.id} value={p.id}>
                          <ListItemText primary={p.nome} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* Status */}
                <Grid item xs={12} md={3}>
                  <FormControl fullWidth>
                    <InputLabel id="label-status">Situação</InputLabel>
                    <Select
                      labelId="label-status"
                      label="Situação"
                      name="status"
                      value={formData.status}
                      onChange={(e) => handleChange(e, 1)}
                      sx={{ height: "0" }}
                    >
                      <MenuItem value="A">Ativo</MenuItem>
                      <MenuItem value="I">Inativo</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {/* Aceite */}
                <Grid item xs={12} md={3}>
                  <TextField
                    label="Aceite do Termo de Uso"
                    value={formData.datAceite || ""}
                    disabled
                    fullWidth
                  />
                </Grid>

                {/* BOTÕES */}
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mt: 3,
                    }}
                  >
                    <Button
                      variant="contained"
                      sx={{ backgroundColor: "#1a3865" }}
                      onClick={handleVoltar}
                    >
                      Voltar
                    </Button>

                    <Button
                      type="submit"
                      variant="contained"
                      sx={{ backgroundColor: "#1a3865" }}
                    >
                      Salvar
                    </Button>
                  </Box>
                </Grid>

              </Grid>
            </Grid>

          </Grid>
        </form>
      </Box>

    </div>
  );
}
